import React from "react";

export const Heart = ({ color, ...rest }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.9701 22.3086C11.7939 22.3086 11.5825 22.2465 11.3358 22.1223C11.0891 21.998 10.846 21.8566 10.6064 21.6978C8.66819 20.4556 6.97317 19.1478 5.52131 17.7744C4.07649 16.3942 2.95587 14.976 2.15946 13.5198C1.36305 12.0567 0.964844 10.5867 0.964844 9.10984C0.964844 8.08844 1.13047 7.16367 1.46172 6.33551C1.80002 5.50045 2.26166 4.78271 2.84663 4.1823C3.43161 3.58189 4.10468 3.1195 4.86585 2.79514C5.63407 2.47077 6.45163 2.30859 7.31852 2.30859C8.39685 2.30859 9.32365 2.57429 10.0989 3.1057C10.8812 3.63019 11.505 4.31342 11.9701 5.15538C12.4353 4.31342 13.0555 3.63019 13.8308 3.1057C14.6131 2.57429 15.5434 2.30859 16.6217 2.30859C17.4816 2.30859 18.2956 2.47077 19.0638 2.79514C19.8321 3.1195 20.5051 3.58189 21.0831 4.1823C21.668 4.78271 22.1261 5.50045 22.4574 6.33551C22.7957 7.16367 22.9648 8.08844 22.9648 9.10984C22.9648 10.5867 22.5666 12.0567 21.7702 13.5198C20.9738 14.976 19.8532 16.3942 18.4084 17.7744C16.9636 19.1478 15.2721 20.4556 13.3339 21.6978C13.0943 21.8566 12.8511 21.998 12.6044 22.1223C12.3578 22.2465 12.1463 22.3086 11.9701 22.3086Z"
        fill={color}
      />
    </svg>
  );
};
